export default __webpack_public_path__ + "static/24934223-day-78143bb644b722b0a5266f60439a0c27.ogv";